import ModalCustomer from '../components/customers/CustomerModal.vue';
import ModalProduct from '../components/products/ProductModal.vue';
import ModalOrder from '../components/orders/OrderModal.vue';
import ModalFamily from '../components/families/FamilyModal.vue';
import ModalShop from '../components/shops/ShopModal.vue';
import ModalUser from '../components/users/UserModal.vue';
import ModalRecurrence from '../components/recurrences/RecurrenceModal.vue';
import ModalCartProduct from '../components/carts/CartProductModal.vue';
import ModalProductsFilters from '../components/products/ProductsFiltersModal.vue';
import ModalCustomersFilters from '../components/customers/CustomersFiltersModal.vue';
import ModalFamiliesFilters from '../components/families/FamiliesFiltersModal.vue';
import ModalShopsFilters from '../components/shops/ShopsFiltersModal.vue';
import ModalUsersFilters from '../components/users/UsersFiltersModal.vue';
import ModalOrdersFilters from '../components/orders/OrdersFiltersModal.vue';
import ModalRecurrencesFilters from '../components/recurrences/RecurrencesFiltersModal.vue';
import ModalCartsFilters from '../components/carts/CartsFiltersModal.vue';
import ModalReportOrdersLabels from '../components/reports/ReportOrdersLabelsModal.vue';
import ModalReportOrdersVendor from '../components/reports/ReportOrdersVendorModal.vue';
import ModalReportOrdersLab from '../components/reports/ReportOrdersLabModal.vue';
import ModalNotificationsFilters from '../components/notifications/NotificationsFiltersModal.vue';
import ModalNotificationCartsExpiringSoon from '../components/notifications/NotificationCartsExpiringSoonModal.vue';
import ModalNotificationRecurringOrderProductNotEnoughStock from '../components/notifications/NotificationRecurringOrderProductNotEnoughStockModal.vue';
import ModalNotificationRecurringOrderProductNotActive from '../components/notifications/NotificationRecurringOrderProductNotActiveModal.vue';

export default {
  components: {
    // Resources
    ModalCustomer,
    ModalProduct,
    ModalOrder,
    ModalFamily,
    ModalShop,
    ModalUser,
    ModalRecurrence,
    ModalCartProduct,

    // Filters
    ModalProductsFilters,
    ModalCustomersFilters,
    ModalFamiliesFilters,
    ModalUsersFilters,
    ModalShopsFilters,
    ModalOrdersFilters,
    ModalRecurrencesFilters,
    ModalCartsFilters,
    ModalNotificationsFilters,

    // Reports
    ModalReportOrdersLabels,
    ModalReportOrdersVendor,
    ModalReportOrdersLab,

    // Notifications
    ModalNotificationCartsExpiringSoon,
    ModalNotificationRecurringOrderProductNotActive,
    ModalNotificationRecurringOrderProductNotEnoughStock,
  },
};
